import { UsersState } from './users.types';

// Constants
export const EMPTY_ARRAY_LENGTH = 0;
export const USERS_FETCHING_ERROR_PREFIX = 'Error fetching users: ';
export const USER_CREATION_ERROR_PREFIX = 'Error creating user: ';
export const USER_REMOVAL_ERROR_PREFIX = 'Error removing user: ';
export const USER_PRIVILEGES_UPDATE_ERROR_PREFIX = 'Error updating user privileges: ';
export const USER_UPDATE_ERROR_PREFIX = 'Error updating user: ';

export const GUEST_ACCOUNT_LOGIN = 'anonymous';

// Initial state
export const USERS_INITIAL_STATE: UsersState = {
  list: [],
  status: 'idle',
  error: null,
};
